import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import SurveyModal from "./SurveyModal";

const SurveyGate = () => {
  const { user, loading } = useContext(AuthContext);
  const [showSurvey, setShowSurvey] = useState(false);

  // only run effect when not loading
  useEffect(() => {
    if (!loading) {
      // Debug: Log user object
      console.log("SurveyGate - Full user object:", user);
      console.log("SurveyGate - user.survey:", user?.survey);
      console.log("SurveyGate - user.survey?.completed:", user?.survey?.completed);

      // user must exist, be inactive, AND not have completed the survey
      if (user && user.uid && user.status === "inactive") {
        const surveyCompleted = user.survey?.completed === true;
        console.log("SurveyGate - surveyCompleted:", surveyCompleted);
        console.log("SurveyGate - showSurvey will be:", !surveyCompleted);
        setShowSurvey(!surveyCompleted);
      } else {
        setShowSurvey(false); // ensure modal never shows otherwise
      }
    }
  }, [user, loading]);

  // completely hide until we know auth state
  if (loading || !user || !user.uid) return null;

  return <SurveyModal visible={showSurvey} />;
};


export default SurveyGate;